<template>
  <section class="spire-section">
    <header class="spire-section__header">
      <component :is="heading" class="spire-section__heading">{{
        text
      }}</component>
      <slot name="button"></slot>
    </header>
    <div v-if="$slots.intro" class="spire-section--intro">
      <slot name="intro"> </slot>
    </div>
    <slot></slot>
  </section>
</template>
<script setup lang="ts">
withDefaults(defineProps<{ text: string; heading?: "h2" | "h3" }>(), {
  heading: "h2",
});
</script>
